import { basicValidation, LanguageCode, languageValidation, Segmentation, SurveySegmentation } from "../..";
import { surveyValidation } from "../fieldValidation/fields/surveyFieldValidation";


export type SurveySegmentationObjectValidationResult =
      'valid'
    | 'invalid_segmentation' 
    | 'invalid_segmentation_value_count' 
    | 'invalid_segmentation_value'
    | 'duplicate_segmentation_value' 
    | 'invalid_segmentation_name'
    | 'invalid_segmentation_translation'

function validateSegmentationValues(values:string[]):SurveySegmentationObjectValidationResult
{
    if(!Array.isArray(values))
        return 'invalid_segmentation';
    if(values.length < 2)
        return 'invalid_segmentation_value_count';
    if(!values.every(v => surveyValidation.surveySegmentation.validateSegmentationValue(v).success))
        return 'invalid_segmentation_value';
    if(!basicValidation.arrayStringsAreUnique(values))
        return 'duplicate_segmentation_value';

    return 'valid';
}

function validateBaseSegmentation(seg:Segmentation): SurveySegmentationObjectValidationResult
{
    if(!seg)
        return 'invalid_segmentation';

    const nameValidation = surveyValidation.surveySegmentation.validateSegmentationName(seg.name);
    if(!nameValidation.success)
        return 'invalid_segmentation_name';

    const valuesValidation = validateSegmentationValues(seg.values);
    if(valuesValidation !== 'valid')
        return valuesValidation;

    return 'valid';
}

function segmentation(seg:SurveySegmentation, requiredTranslations:LanguageCode[]): SurveySegmentationObjectValidationResult 
{
    const baseValidation = validateBaseSegmentation(seg);
    if(baseValidation !== 'valid')
        return baseValidation;
    
    if(!languageValidation.identicalLanguageCodes(requiredTranslations, seg.translations.map(t => t.languageCode)))
        return 'invalid_segmentation_translation';

    if(seg.translations.some(t => !validateBaseSegmentation(t)))
        return 'invalid_segmentation_translation';

    return 'valid';
}

function segmentationList(value:SurveySegmentation[], requiredTranslations:LanguageCode[]): SurveySegmentationObjectValidationResult 
{
    if(value === null || value === undefined || !Array.isArray(value))
        return 'invalid_segmentation';
    
    for(let i=0; i<value.length; i++)
    {
        const validation = segmentation(value[i], requiredTranslations);
        if(validation !== 'valid')
            return validation;
    }
    
    if(!basicValidation.stringValuesAreUnique(value.map(s => s.name)))
        return 'invalid_segmentation';

    return 'valid';
}

export const surveySegmentationObjectValidation = {
    segmentation,
    segmentationList
};
